import React from 'react';
import moment from 'moment';
import renderHtml from 'react-render-html';

const EventEntryPopover = ({ schedule }) => {
  const { title, startDate, eventTime, marketingLink, isInternalLink } =
    schedule;
  const formattedMarketingLink = `${marketingLink}?date=${moment(
    startDate
  ).format('YYYY-MM-DD')}`;

  return (
    <div className="event-entry">
      {eventTime && <p className="event-time">{eventTime}</p>}
      {marketingLink ? (
        <a
          href={formattedMarketingLink}
          target={!isInternalLink ? '_blank' : '_self'}
          rel="noopener noreferrer"
          className="event-cta-link"
        >
          {renderHtml(title)}
        </a>
      ) : (
        <p className="event-title">{renderHtml(title)}</p>
      )}
    </div>
  );
};

export default EventEntryPopover;
